/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1PodOS
 */
export interface V1PodOS {
    /**
     * 
     * @type {string}
     * @memberof V1PodOS
     */
    name?: string;
}

export function V1PodOSFromJSON(json: any): V1PodOS {
    return V1PodOSFromJSONTyped(json, false);
}

export function V1PodOSFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1PodOS {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function V1PodOSToJSON(value?: V1PodOS | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

